<p-dialog
  [visible]="visible()"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '767px': '100vw' }"
  [style]="{ width: '560px' }"
  styleClass="no-header-modal"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <div
      class="surface-0 sticky left-0 top-0 w-full z-1 border-bottom-1 border-300 p-3 flex align-items-center justify-content-between"
    >
      <h2 class="mb-0 text-sm line-height-1">
        {{ 'SUBSCRIPTIONS.PAYMENT_TIMELINE.EDIT.HEADER' | translate }}
      </h2>
      <button
        type="button"
        class="fa fa-times text-xl text-600 cursor-pointer border-none bg-transparent p-0"
        aria-label="close-edit-payment-timeline-popup"
        data-testid="close-edit-payment-timeline-popup"
        (click)="onClose()"
      ></button>
    </div>

    <div>
      <p-message
        severity="info"
        styleClass="relative"
        aria-label="staff-discount-limit-message"
        data-testid="staff-discount-limit-message"
      >
        <span
          class="ml-2"
          [innerHTML]="
            'SUBSCRIPTIONS.PAYMENT_TIMELINE.EDIT.STAFF_DISCOUNT_LIMIT_MSG' | translate: { perc: (recurringStaffDiscount() | number: '1.0-2') }"
        ></span>
      </p-message>
    </div>

    @if (occurrence(); as selectedOccurrence) {
      <div class="p-3 border-bottom-1 border-200">
        <div class="grid text-sm">
          <div class="col-6">
            <span class="text-600 block mb-1 uppercase text-xs">
              {{ 'SUBSCRIPTIONS.PAYMENT_TIMELINE.EDIT.START_DATE' | translate }}
            </span>
            <strong>
              {{ selectedOccurrence.occurance_start_date | datetimeformat: 'defaultformat' }}
            </strong>
          </div>
          <div class="col-6">
            <span class="text-600 block mb-1 uppercase text-xs">
              {{ 'SUBSCRIPTIONS.PAYMENT_TIMELINE.EDIT.END_DATE' | translate }}
            </span>
            <strong>
              {{ selectedOccurrence.occurance_end_date | datetimeformat: 'defaultformat' }}
            </strong>
          </div>
          <div class="col-6">
            <span class="text-600 block mb-1 uppercase text-xs">
              {{ 'SUBSCRIPTIONS.PAYMENT_TIMELINE.EDIT.BASE_AMOUNT' | translate }}
              ({{ taxCalculationLabelKey() | translate }})
            </span>
            <strong>
              {{ discountBaseAmountMinor() | currencyformat }}
            </strong>
          </div>
         
        </div>
      </div>
    }

    <form [formGroup]="editForm" class="p-3" (ngSubmit)="onSubmit()">
      <div class="mb-4">
        <label for="adjustment-scope-toggle" class="font-medium text-700 text-xs mb-2 block uppercase">
          {{ 'SUBSCRIPTIONS.PAYMENT_TIMELINE.EDIT.ADJUSTMENT_SCOPE' | translate }}
          <sup class="p-error">*</sup>
        </label>
        <p-selectButton
          [options]="adjustmentScopeOptions()"
          formControlName="adjustment_scope"
          optionLabel="label"
          optionValue="value"
          [allowEmpty]="false"
          aria-label="adjustment-scope-toggle"
          data-testid="adjustment-scope-toggle"
        />
      </div>

      <div class="mb-4">
        <label
          for="new-recurring-amount-input"
          class="font-medium text-700 text-xs mb-2 block uppercase"
        >
          {{ 'SUBSCRIPTIONS.PAYMENT_TIMELINE.EDIT.NEW_AMOUNT' | translate }}
          <sup class="p-error">*</sup>
        </label>
        <p-inputNumber
          inputId="new-recurring-amount-input"
          formControlName="new_amount"
          mode="decimal"
          [minFractionDigits]="2"
          [maxFractionDigits]="3"
          class="text-sm w-full"
          inputStyleClass="w-full text-sm"
          aria-label="new-recurring-amount-input"
          data-testid="new-recurring-amount-input"
          (onBlur)="onNewAmountBlur()"
          (onInput)="onNewAmountInput()"
          [ngClass]="{
            'ng-invalid ng-dirty':
              NewAmountControl?.touched &&
              (NewAmountControl?.invalid || invalidRecurringDiscount()),
          }"
        />
        @if (invalidRecurringDiscount() && NewAmountControl?.touched) {
          <p-message
            severity="error"
            icon="fa fa-exclamation-triangle"
            styleClass="mt-2 w-full"
            aria-label="invalid-recurring-discount-message"
            data-testid="invalid-recurring-discount-message"
          >
            {{ 'POS.MEMBERSHIP_ADDON.YOUCANNOTAPPLY' | translate }}
            {{ recurringStaffDiscount() | number: '1.0-2' }}%
            {{ 'POS.MEMBERSHIP_ADDON.DISCOUNT' | translate }}
          </p-message>
        }
        @if (NewAmountControl?.touched && NewAmountControl?.invalid) {
          <app-error-msg
            styleClass="md:block"
            [errors]="NewAmountControl?.errors"
            [fieldLabel]="'SUBSCRIPTIONS.PAYMENT_TIMELINE.EDIT.NEW_AMOUNT' | translate"
          />
        }
      </div>

      @if(false){
      <div class="mb-4">
        <label
          for="adjustment-reason-code-input"
          class="font-medium text-700 text-xs mb-2 block uppercase"
        >
          {{ 'SUBSCRIPTIONS.PAYMENT_TIMELINE.EDIT.REASON_CODE' | translate }}
          <sup class="p-error">*</sup>
        </label>
        <input
          pInputText
          id="adjustment-reason-code-input"
          formControlName="adjustment_reason_code"
          class="w-full text-sm"
          aria-label="adjustment-reason-code-input"
          data-testid="adjustment-reason-code-input"
          [ngClass]="{
            'ng-invalid ng-dirty':
              ReasonCodeControl?.invalid && ReasonCodeControl?.touched,
          }"
        />
        @if (ReasonCodeControl?.touched && ReasonCodeControl?.invalid) {
          <app-error-msg
            styleClass="md:block"
            [errors]="ReasonCodeControl?.errors"
            [fieldLabel]="'SUBSCRIPTIONS.PAYMENT_TIMELINE.EDIT.REASON_CODE' | translate"
          />
        }
      </div>
    }

      <div class="mb-4">
        <label
          for="adjustment-notes-input"
          class="font-medium text-700 text-xs mb-2 block uppercase"
        >
          {{ 'SUBSCRIPTIONS.PAYMENT_TIMELINE.EDIT.NOTES' | translate }}
        </label>
        <textarea
          pTextarea
          id="adjustment-notes-input"
          formControlName="adjustment_notes"
          rows="3"
          class="w-full text-sm"
          aria-label="adjustment-notes-input"
          data-testid="adjustment-notes-input"
        ></textarea>
      </div>

      <div class="flex justify-content-end gap-2 border-top-1 border-300 pt-3">
        <p-button
          type="button"
          styleClass="p-button-outlined text-sm"
          [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
          aria-label="cancel-edit-payment-timeline"
          data-testid="cancel-edit-payment-timeline"
          (click)="onClose()"
        />
        <p-button
          type="submit"
          styleClass="text-sm"
          [label]="'common.BUTTONS.BUTTON-TEXT-SAVE' | translate"
          [loading]="isSubmitting()"
          [disabled]="editForm.invalid || isSubmitting() || invalidRecurringDiscount()"
          aria-label="save-edit-payment-timeline"
          data-testid="save-edit-payment-timeline"
        />
      </div>
    </form>
  </ng-template>
</p-dialog>
